import { Box, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import WebRelatedPagesWrapper from "components/WebRelatedPagesWrapper";
import React from "react";
import { fontSizes, fontWeights, lineHeights } from "theme/fonts";
import appColors from "theme/appColors";
import { WEBSITE_DASHBOARD } from "navigation/routes";

function SubscriptionPolicy() {
  const breadcrumbdata = {
    parent: "Home",
    parentLink: WEBSITE_DASHBOARD,
    currentPage: "Subscription Policy",
  };
  const pagedata = {
    title: "Subscription Policy",
  };

  const bundleRenewalOptions = [
    {
      name: "Individual Content Renewal",
      description:
        "Renew only the specific content items that have expired or that the user wishes to continue accessing.",
    },
    {
      name: "Bundle Renewal",
      description:
        "Renew the entire bundle as a single purchase, subject to the bundle availability and applicable pricing at the time of renewal.",
    },
  ];

  return (
    <WebRelatedPagesWrapper
      breadCrumbContent={breadcrumbdata}
      pageData={pagedata}
    >
      <Box
        py="2em"
        w="fit-content"
        mx="auto"
        maxW={{ md: "70vw", lg: "800px" }}
        px={{ base: "2em", md: "0" }}
        fontSize={{ base: fontSizes.sm, lg: fontSizes.md }}
        fontWeight={fontWeights.sm}
        lineHeight={{ base: lineHeights.sm, lg: lineHeights.md }}
        color={appColors.brandGrey["700"]}
      >
        <Text my="1em" fontWeight={fontWeights.xl}>
          Overview
        </Text>
        <Text>
          Our subscription model provides users with access to the digital
          content within the application. All purchased content is intended
          for consumption exclusively inside the app and cannot be
          transferred, downloaded, or used outside the application unless
          explicitly stated.
        </Text>

        <Text my="1em" fontWeight={fontWeights.xl}>
          Content Access & Validity
        </Text>
        <Text>
          Every purchased content subscription is valid for 1 year from the
          date of purchase. During the validity period, users will have
          uninterrupted access to the purchased content within the
          application. Once the subscription expires, access to the
          purchased content will be discontinued until it is renewed.
        </Text>

        <Text my="1em" fontWeight={fontWeights.xl}>
          Subscription Renewal
        </Text>
        <Text>
          Subscription renewal is not automatic. Users are required to
          manually renew their subscription if they wish to continue
          accessing the expired content. Renewal pricing may include
          discounts. Any renewal discounts, when applicable, will be
          displayed at the time of renewal.
        </Text>

        <Text my="1em" fontWeight={fontWeights.xl}>
          Bundle Purchases
        </Text>
        <Text>
          Users may purchase multiple content items together as a bundle.
          Each content item within a bundle has its own independent 1 year
          validity from the date of purchase. The expiry of one content item
          does not affect the validity of other content items within the
          bundle.
        </Text>

        <Text my="1em" fontWeight={fontWeights.xl}>
          Bundle Renewal Options
        </Text>
        <Text my="0.5em">
          When a bundle or its individual content expires, users may choose
          either of the following renewal options:
        </Text>
        <UnorderedList>
          {bundleRenewalOptions.map((each) => (
            <ListItem key={each.name}>
              <Text as="span" fontWeight={fontWeights.md}>
                {each.name}
              </Text>
              <Text my="0.5em">{each.description}</Text>
            </ListItem>
          ))}
        </UnorderedList>
        <Text mt="1em">
          Applicable renewal discounts, if any, will be calculated based on
          the eligibility of the selected content or bundle.
        </Text>

        <Text my="1em" fontWeight={fontWeights.xl}>
          Pricing
        </Text>
        <Text>
          Subscription, renewal, and bundle pricing are subject to change
          without prior notice. Any promotional offers or discounts are
          provided at the platform's discretion and may vary based on
          content, bundle, or promotional campaigns.
        </Text>

        <Text my="1em" fontWeight={fontWeights.xl}>
          Refunds & Cancellations
        </Text>
        <Text>
          Purchases and renewals are generally non-refundable except where
          required by applicable law or the platform's refund policy. Since
          subscriptions require manual renewal, users will not be charged
          automatically after the validity period expires.
        </Text>

        <Text my="1em" fontWeight={fontWeights.xl}>
          Changes to the Subscription Policy
        </Text>
        <Text>
          We reserve the right to modify this Subscription Policy at any
          time. Any updates will become effective upon publication within
          the application. Continued use of the application after such
          updates constitutes acceptance of the revised policy.
        </Text>
      </Box>
    </WebRelatedPagesWrapper>
  );
}

export default SubscriptionPolicy;
